// NEW: UI_REVAMP
import {
	Box,
	Drawer,
	DrawerBody,
	DrawerCloseButton,
	DrawerContent,
	DrawerHeader,
	DrawerOverlay,
	Flex,
	useMediaQuery,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { useBottomSheetStore } from '../hooks/useBottomSheetStore';
import ImgComp from './ImgComp';

const BottomSheetContainer = ({
	id,
	isOpen,
	children,
	height = 'calc(100dvh - 82px - env(safe-area-inset-top, 0px))',
	showOverlay = false,
	onCloseExtra,
}) => {
	const close = useBottomSheetStore((s) => s.closeBottomSheet);
	const activeSheet = useBottomSheetStore((s) => s.activeSheet);
	const resolvedIsOpen = id ? activeSheet === id : !!isOpen;

	const handleClose = () => {
		close();
		onCloseExtra?.();
	};

	const [isLargeScreen] = useMediaQuery('(min-width: 992px)');

	useEffect(() => {
		if (isLargeScreen && resolvedIsOpen) {
			close();
		}
	}, [isLargeScreen, resolvedIsOpen, close]);

	return (
		<Drawer placement='bottom' isOpen={resolvedIsOpen} onClose={handleClose}>
			{showOverlay && <DrawerOverlay />}
			<DrawerContent
				h={height}
				boxShadow='0 -2px 4px 0 rgba(180, 206, 243, 0.20)'
				borderTopRadius={16}
				position='relative'
			>
				{children}
			</DrawerContent>
		</Drawer>
	);
};

const BottomSheetContent = ({ title, children }) => {
	return (
		<>
			<DrawerCloseButton />
			<DrawerHeader fontSize='14px' fontWeight={600} color='black' p={2}>
				{title}
			</DrawerHeader>
			<DrawerBody p={0}>{children}</DrawerBody>
		</>
	);
};

const BottomSheetExpandable = ({ isOpen, onToggle, children }) => {
	return (
		<Box
			bg='rgba(238, 233, 254, 0.5)'
			borderTopRadius={16}
			p={2}
			position='absolute'
			zIndex={10}
			bottom={0}
			left={0}
			right={0}
			backdropFilter='blur(10px)'
		>
			<Box
				position='absolute'
				inset={0}
				border='2px	solid rgba(163, 151, 242, 1)'
				borderTopRadius={16}
				sx={{
					maskImage: `linear-gradient(to bottom,rgba(255,255,255,1) 0%,rgba(255,255,255,1)  25%,transparent 75%,transparent 100%)`,
					maskSize: '100% 100%',
					maskRepeat: 'no-repeat',
					WebkitMaskImage: `linear-gradient(to bottom,rgba(255,255,255,1)  0%,rgba(255,255,255,1)  25%,transparent 75%,transparent 100%)`,
					WebkitMaskSize: '100% 100%',
					WebkitMaskRepeat: 'no-repeat',
				}}
				pointerEvents='none'
			/>
			<Flex
				justifyContent='center'
				alignItems='center'
				py={1}
				mb={2}
				cursor='pointer'
				onClick={onToggle}
			>
				<ImgComp
					svgName='chevron-down'
					w={5}
					h={5}
					transform={`rotate(${isOpen ? 180 : 0}deg)`}
					transition='0.2s ease'
				/>
			</Flex>

			{isOpen && children}
		</Box>
	);
};

const BottomSheet = ({
	id,
	isOpen,
	title,
	mainContent,
	expandContent,
	isExpandOpen,
	onToggleExpand,
	height,
	showOverlay,
	onClose,
}) => {
	return (
		<BottomSheetContainer
			id={id}
			isOpen={isOpen}
			height={height}
			showOverlay={showOverlay}
			onCloseExtra={onClose}
		>
			<BottomSheetContent title={title}>
				{mainContent}

				{expandContent && (
					<BottomSheetExpandable isOpen={isExpandOpen} onToggle={onToggleExpand}>
						{expandContent}
					</BottomSheetExpandable>
				)}
			</BottomSheetContent>
		</BottomSheetContainer>
	);
};

export default BottomSheet;
